document.addEventListener("DOMContentLoaded", function () {

    const swiperIndexNabidky = new Swiper('.JS-index-nabidky', {
        speed: 400,
        spaceBetween: 20,
        slidesPerView: 1.2,
        navigation: {
            nextEl: '.swiper-button-next',
        },
        simulateTouch: true,
        touchRatio: 1,
        grabCursor: true,
        autoplay: false,
        breakpoints: {
            1024: {
                slidesPerView: 1.5,
                spaceBetween: 30,
            },
            1600: {
                slidesPerView: 2.5,
                spaceBetween: 40,
            }
        },
    });
});
